/**
 * One sentence per transfer failure code, for every surface that shows one
 * (card `t_8ae1d20a`/E2's page, card `t_92f7411f`/E3's dashboard entry).
 *
 * The composable answers CODES — it never decides which language the reader
 * speaks — so the sentences live with the surfaces, in the six catalogues. They
 * are read through this map, which the locale audit cannot see (a dynamic `t()`
 * key is invisible to it), so `SettingsModel.contract.test.ts` and
 * `EditDashboardModal.scan.contract.test.ts` assert every key here by name in
 * all six catalogues.
 */
import type { ScanTransferErrorCode } from '../composables/useScanUpload';
import type { ScanAttachErrorCode } from '../services/scanModelAttach';

/** `[key, english]` — the fallback is what a catalogue that lost the key shows. */
export const TRANSFER_ERROR_SENTENCES: Record<ScanTransferErrorCode, [string, string]> = {
  'no-hub': ['views.scans.errors.noHub', 'The hub could not be reached'],
  auth: ['views.scans.errors.auth', 'The hub refused this session'],
  validation: ['views.scans.errors.validation', 'The hub refused the package'],
  'read-failed': ['views.scans.errors.readFailed', 'The capture could not be read'],
  'upload-failed': ['views.scans.errors.uploadFailed', 'The upload did not finish'],
  'download-failed': ['views.scans.errors.downloadFailed', 'The download did not finish'],
  'save-failed': ['views.scans.errors.saveFailed', 'The file could not be saved'],
  unknown: ['views.scans.errors.unknown', 'The transfer did not finish'],
};

/**
 * …and one for each way "use this scan as the model" can fail (the dashboard
 * editor and the model upload modal both show them, card t_92f7411f).
 */
export const SCAN_ATTACH_SENTENCES: Record<ScanAttachErrorCode, [string, string]> = {
  'no-model': ['views.scans.model.noModel', 'No model file in this package'],
  'fetch-failed': ['views.scans.model.fetchFailed', 'The scan could not be read off the hub'],
  'attach-failed': [
    'views.scans.model.attachFailed',
    'The scan could not become the hub’s 3D model',
  ],
};
